/* tslint:disable */
/* eslint-disable */
/* @relayHash 9975e042af992f45986f8597fd91f263 */

import { ConcreteRequest } from "relay-runtime";
export type WORKSHEET_VISIBILITY = "EVERYONE" | "LOGGED_IN" | "PASSWORD" | "%future added value";
export type CreateWorksheetInput = {
    title?: string | null;
    description?: string | null;
    password?: string | null;
    visibility?: WORKSHEET_VISIBILITY | null;
    clientMutationId?: string | null;
};
export type CreateWorksheetMutationVariables = {
    input: CreateWorksheetInput;
};
export type CreateWorksheetMutationResponse = {
    readonly createWorksheet: {
        readonly worksheet: {
            readonly id: string;
            readonly title: string | null;
            readonly description: string | null;
            readonly identifier: string | null;
            readonly isPublished: boolean;
        } | null;
    } | null;
};
export type CreateWorksheetMutation = {
    readonly response: CreateWorksheetMutationResponse;
    readonly variables: CreateWorksheetMutationVariables;
};



/*
mutation CreateWorksheetMutation(
  $input: CreateWorksheetInput!
) {
  createWorksheet(input: $input) {
    worksheet {
      id
      title
      description
      identifier
      isPublished
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateWorksheetInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createWorksheet",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateWorksheetPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "worksheet",
        "storageKey": null,
        "args": null,
        "concreteType": "Worksheet",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "identifier",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isPublished",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateWorksheetMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateWorksheetMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateWorksheetMutation",
    "id": null,
    "text": "mutation CreateWorksheetMutation(\n  $input: CreateWorksheetInput!\n) {\n  createWorksheet(input: $input) {\n    worksheet {\n      id\n      title\n      description\n      identifier\n      isPublished\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'f39756bd766863edba1001e68f8a2699';
export default node;
